export enum State {
    localizando,
    inserindo,
    editando    
}